export default __webpack_public_path__ + "static/media/red-cross.8325c442.svg";